var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.86 70.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e1258992-202e-4133-8a33-e986b1bd4ec7",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7a8ea40-ed9e-4203-98fc-ec83370098e7",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.79 0 35.43 28.36 7.07 0 0 7.07 28.36 35.43 0 63.79 7.07 70.86 35.43 42.5 63.79 70.86 70.86 63.79 42.5 35.43 70.86 7.07 63.79 0",
    fill: "#c62221"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo1);
export default __webpack_public_path__ + "static/media/no_1.0eadcf57a945f67be3a2ca15b4c298f9.svg";
export { ForwardRef as ReactComponent };